import { Theme } from '@mui/material/styles'
export const getStyles = (theme: Theme) => ({
  root: {
    alignItems: 'center',
    display: 'flex',
    height: '100%',
  },

  label: {
    marginLeft: theme.spacing(0.5),
    marginRight: theme.spacing(2.5),
  },
})
